// ICCS 坐标记谱 — https://www.xqbase.com/protocol/cchess_move.htm
// 简化形式: from-square + to-square, 全小写, e.g. "h2e2" = 炮二平五
// 文件 a-i 左到右; 排 0-9 下到上 (a0=红方左下)

import { Move, fileOf, rankOf } from './types';

const FILE_CHARS = 'abcdefghi';

export function moveToICCS(move: Move): string {
  const ff = FILE_CHARS[fileOf(move.from)];
  const fr = rankOf(move.from);
  const tf = FILE_CHARS[fileOf(move.to)];
  const tr = rankOf(move.to);
  return `${ff}${fr}${tf}${tr}`;
}

// 中文纵线格式 (简化版): 红/黑双方都用阿拉伯数字 + 进/退/平
// 不是完整规范, 仅做 UI 展示
const RED_NUM = ['一','二','三','四','五','六','七','八','九'];
const PIECE_NAME_RED: Record<string, string> = {
  K: '帅', A: '仕', B: '相', N: '马', R: '车', C: '炮', P: '兵',
};
const PIECE_NAME_BLACK: Record<string, string> = {
  K: '将', A: '士', B: '象', N: '马', R: '车', C: '炮', P: '卒',
};

export function moveToChinese(move: Move, pieceType: string, color: 'r' | 'b'): string {
  // file 数从该方右侧起计 (红: i=1, a=9; 黑: a=1, i=9)
  const fromFile = color === 'r' ? (8 - fileOf(move.from)) + 1 : fileOf(move.from) + 1;
  const toFile = color === 'r' ? (8 - fileOf(move.to)) + 1 : fileOf(move.to) + 1;
  const nameFn = color === 'r' ? PIECE_NAME_RED : PIECE_NAME_BLACK;
  const name = nameFn[pieceType];
  const fromFileStr = color === 'r' ? RED_NUM[fromFile - 1] : String(fromFile);
  const toFileStr = color === 'r' ? RED_NUM[toFile - 1] : String(toFile);

  // 判方向: 同列 → 平+目标列; rank 向敌方 → 进; rank 向己方 → 退
  let dir: string;
  let tail: string;
  if (fileOf(move.from) === fileOf(move.to)) {
    // 纵向: 红进=rank+, 黑进=rank-; 退反之
    const forwardRed = rankOf(move.to) > rankOf(move.from);
    const isAdvance = color === 'r' ? forwardRed : !forwardRed;
    dir = isAdvance ? '进' : '退';
    tail = color === 'r' ? RED_NUM[Math.abs(rankOf(move.to) - rankOf(move.from)) - 1] : String(Math.abs(rankOf(move.to) - rankOf(move.from)));
  } else if (rankOf(move.from) === rankOf(move.to)) {
    dir = '平';
    tail = toFileStr;
  } else {
    // 斜走 (仕/相/马): 方向 = 进/退; 尾数 = 目标列
    const forwardRed = rankOf(move.to) > rankOf(move.from);
    const isAdvance = color === 'r' ? forwardRed : !forwardRed;
    dir = isAdvance ? '进' : '退';
    tail = toFileStr;
  }
  return `${name}${fromFileStr}${dir}${tail}`;
}
